
export default {
  // component: Personnel,
  component: load(() => import(/* webpackChunkName: "Personnel" */ './AppSetting')),
  priority: 1,
  permissions: ['',"isAdmin"],
  name: app.translate('routes.home.AppSetting'),
  icon: 'account',
  drawer: true,
};
